import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { Role, RoleDataRequest } from 'src/app/auth/models/role.model';
import { BackendResponse } from 'src/app/shared/models/backend-response.model';
import { unwrap } from 'src/app/shared/rxjs-operators/unwrap';

@Injectable({ providedIn: 'root' })
export class RolesService {
  http = inject(HttpClient);

  // BOILERPLATE TODO: Talk with project manager about adding roles to base data guard, cache them in this service,
  // or get them from backend everytime. This depends a lot on the project features and needs.
  // BOILERPLATE TODO: Uncomment all caching lines if its the strategy to use in this project
  // private cachedRoles?: Role[];

  getList(): Observable<Role[]> {
    // BOILERPLATE TODO: Uncomment if using cache
    // return this.cachedRoles
    //   ? of(this.cachedRoles)
    //   : this.http.get<Role[]>('Roles').pipe(tap(roles => this.cachedRoles = roles));

    // BOILERPLATE TODO: Remove if using cache
    return this.http.get<Role[]>('Roles');
  }

  get(id: string): Observable<Role> {
    return this.http.get<Role>(`Roles/${id}`);
  }

  create(role: RoleDataRequest): Observable<void> {
    return this.http.post<BackendResponse<void>>('Roles/Create', role).pipe(unwrap());
  }

  update(role: RoleDataRequest, id: string): Observable<void> {
    return this.http.put<BackendResponse<void>>(`Roles/${id}`, role).pipe(unwrap());
  }

  delete(id: string): Observable<void> {
    return this.http.delete<BackendResponse<void>>(`Roles/${id}`).pipe(unwrap());
  }
}
